import { Pipe, PipeTransform } from '@angular/core';
import { InvestmentInstructionSubmissionAffectedAccount } from '../../../models/submissions/investment-instruction-submission-affected-account';
import { AccountType } from '../../../models/transactions/account-type';
import { InstructionSubmissionUtils } from '../../../utils/instruction-submission-utils';

@Pipe({ name: 'submissionAffectedAccountDisplayName' })
export class SubmissionAffectedAccountDisplayNamePipe implements PipeTransform {
  transform(account: InvestmentInstructionSubmissionAffectedAccount, accountType: AccountType | null): string {
    return InstructionSubmissionUtils.resolveAccountName(account, accountType);
  }
}
